import { useFormikContext, getIn } from "formik";
import InputFormik from "../../../../../common/components/form/InputFormik";

interface DateSubscriptionFormikProps {
  name?: string;
  validateDate?: (date: Date) => boolean; // Uma função que valida a data
  //eslint-disable-next-line @typescript-eslint/no-explicit-any
  onInvalidDate?: (currentValue: string, setFieldValue: (field: string, value: any) => void) => void; // Função chamada quando a data é inválida
  className?: string;
}

export function DateSubscriptionFormik({
  name = "subscriptionInitialDate",
  validateDate = (date) => { // Função padrão que valida a data para não ser mais de 4 semanas à frente
    const fourWeeksFromNow = new Date();
    fourWeeksFromNow.setDate(fourWeeksFromNow.getDate() + 4 * 7);
    return date <= fourWeeksFromNow;
  },
  onInvalidDate = (_, setFieldValue) => { // Função padrão chamada quando a data é inválida
    alert('A data de início da assinatura não pode ser maior que 4 semanas a partir de hoje!');
    setFieldValue(name, new Date().toISOString().slice(0, 10));
  },
  className = "mt-4" // Valor padrão será "mt-4" se nada for passado

}: DateSubscriptionFormikProps) {
  const { values, setFieldValue } = useFormikContext();
  const dateValue = getIn(values, name);

  const handlerDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedDate = new Date(event.target.value);
    if (validateDate(selectedDate)) {
      const selectedDateStr = selectedDate.toISOString().slice(0, 10);
      setFieldValue(name, selectedDateStr);
    } else {
      onInvalidDate(dateValue, setFieldValue); // Passar setFieldValue para permitir atualização externa
    }
  };

  return (
    <InputFormik
      className={className} // Usa o valor passado ou o padrão
      label="Data de cobrança da primeira parcela - Assinatura"
      name={name}
      type="date"
      required={true}
      value={dateValue}
      onChange={handlerDateChange}
    />
  );
}
